export default function noop() {}



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/d3-geo/src/noop.js
// module id = null
// module chunks = 